@if (loading()) {
	<app-user-detail-skeleton />
} @else {
	@if (user(); as user) {
		<app-users-detail
			[user]="user"
			(userEditClick)="openUserEditModal()" (statusChanged)="changeUserStatus($event)"
			(agentReassignClick)="openAgentReassign()"/>



		<activar-sidebar
			[visible]="visible()"
			(visibleChange)="visible.set($event)"
			>

			<app-client-info-endorsement-form
			[user]="getUserForEndorsementForm()"
			(closed)="exitSidebar()" />

		</activar-sidebar>

		<activar-sidebar
			[visible]="agentSidebarVisible()"
			(visibleChange)="agentSidebarVisible.set($event)"
			>

			<app-agent-reassign-form
			[userId]="currentUserId"
			(confirmed)="exitAgentSidebar()"
			(cancelled)="closeAgentSidebar()" />

		</activar-sidebar>


	}
	
}
